import { yupResolver } from '@hookform/resolvers/yup';
import { TransactionalFootnoteModel } from 'api-hooks/sale/model';
import formSetErrors from 'common/helpers/form-setError';
import { DrawerBody, DrawerFooter } from 'components/common/drawer/styles';
import notification from 'components/common/notification';
import { Form, Input } from 'components/elements';
import { Button } from 'components/elements/buttons';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';

export interface TransactionalFootnoteFormProps {
  transactional: TransactionalFootnoteModel | null;
  onSubmit: (
    input: TransactionalFootnoteFormType,
  ) => Promise<TransactionalFootnoteModel>;
  onClose: () => void;
}

export const TransactionalFootnoteSchema = () =>
  Yup.object({
    description: Yup.string().default(''),
  });

export type TransactionalFootnoteFormType = Yup.InferType<
  ReturnType<typeof TransactionalFootnoteSchema>
> & {
  transactional: TransactionalFootnoteModel | null;
};

export default function TransactionalFootnoteForm(
  props: TransactionalFootnoteFormProps,
) {
  const { t } = useTranslation();
  const defaultValues = React.useMemo<TransactionalFootnoteFormType>(() => {
    return {
      description: props?.transactional?.description ?? '',
      transactional: props.transactional,
    };
  }, [props.transactional]);

  const resolver = yupResolver(TransactionalFootnoteSchema());

  const methods = useForm({
    defaultValues,
    resolver,
  });

  const onSubmit = React.useCallback(
    async (values: TransactionalFootnoteFormType) => {
      try {
        await props.onSubmit(values);
      } catch (e) {
        if (e.errors) {
          formSetErrors(e.errors, methods.setError);
        }
        notification.error({ message: e.message });
      }
    },
    [methods.setError, props],
  );

  return (
    <Form methods={methods} onSubmit={onSubmit}>
      <DrawerBody>
        <Input
          type="text-area"
          name="description"
          label="Description"
          placeholder="Description"
        />
        {props.transactional && (
          <>
            <Input
              type="text"
              name="transactional.employee.name"
              label={t('common:updated_by')}
              placeholder={t('common:updated_by')}
              disabled
            />
            <Input
              type="date-time"
              name="transactional.updatedAt"
              label={t('common:updated_at')}
              placeholder={t('common:updated_at')}
              disabled
            />
          </>
        )}
      </DrawerBody>
      <DrawerFooter>
        <div />
        <div>
          <Button onClick={props.onClose} buttonType="tertiary">
            Cancel
          </Button>
          <Input type="submit" />
        </div>
      </DrawerFooter>
    </Form>
  );
}
